import { QuickBooksSyncDto } from './quickBooksSyncDto'

export class QuickBooksSyncBootstrapDto {
  activeQuickBooksSync?: QuickBooksSyncDto = undefined
  hasPreviousVersions: boolean = false
}
